module.exports = __webpack_public_path__ + "img/eden-egreso-dif-anio-anterior.823263f8.svg";